import { render, staticRenderFns } from "./ConfirmPatientDetailsModalComponent.vue?vue&type=template&id=67e02deb"
import script from "./ConfirmPatientDetailsModalComponent.vue?vue&type=script&lang=js"
export * from "./ConfirmPatientDetailsModalComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports